import React from 'react';
import Navigation from '../components/layout/Navigation';
import Footer from '../components/layout/Footer';
import ProductHero from '../components/sections/ProductHero';
import ProductCategories from '../components/sections/ProductCategories';
import ProductFeatured from '../components/sections/ProductFeatured';

const Products = () => {
  return (
    <div>
      <Navigation />
      <ProductHero />
      <ProductCategories />
      <ProductFeatured />
      <Footer />
    </div>
  );
};

export default Products;
